module.exports = __webpack_public_path__ + "img/4.9ae13bc5.jpg";